import * as React from "react";
import {Order} from "../../../../types/orders/order";
import {orderToOrderIdentifier} from "./interfaces";
import {updateOrderState} from "./fetchers";

import Alert from "../../../Common/Alert"
import {useState} from "react";

interface Props {
    orders: Order[];
    requestNewPage: () => void;
}

export default (props: Props) => {
  const [success, setSuccess] = useState(true);
  const [text, setText] = useState('');
  const [show, setShow] = useState(false);
  const close = () => {
    setShow(false);
  }

  const orderIdentifiers = props.orders
      .map(x => orderToOrderIdentifier(x));

  const buttonFun = (erpState: string): Promise<void> => {
      return updateOrderState(erpState, orderIdentifiers)
          .then(x => {
            const updateOrderStateSuccess = !(x.notUpdated > 0);

            setSuccess(updateOrderStateSuccess);
            setText(updateOrderStateSuccess ? "Actualizado Exitosamente" : x.error);
            setShow(true);
            props.requestNewPage();
          });
  }

  return (
      <React.Fragment>
        <Alert success={success} text={text} show={show} close={close}></Alert>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
          onClick={() => buttonFun("CANCELADO")}
        >
          Cancelar Todo
        </button>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
          onClick={() => buttonFun("REINTENTANDO ENVIO")}
        >
          Reintentar Todo
        </button>
      </React.Fragment>
  );
};
